import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";
import { t } from "i18next";

const CoreAutoComplete = ({ common, label, fetchData, ...props }) => {
  const [inputValue, setInputValue] = useState("");
  const [debouncedInputValue, setDebouncedInputValue] = useState("");

  const colorPrimary = useSelector((state) => state.app.primaryColor);

  const { data: citiesData, isLoading } = fetchData(debouncedInputValue, {
    skip: !debouncedInputValue,
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedInputValue(inputValue.trim());
    }, 750);
    return () => {
      clearTimeout(timer);
    };
  }, [inputValue, setDebouncedInputValue]);

  const handleTextAreaChange = (event) => {
    setInputValue(event.target.value);
  };

  return (
    <>
      <Autocomplete
        size="small"
        isOptionEqualToValue={(option, value) => option.name === value.name}
        getOptionLabel={(option) => option.name}
        options={citiesData?.Data || []}
        loading={isLoading}
        loadingText={t("Loading...")}
        noOptionsText={`${label} non trovato`}
        value={common ? { name: common } : null}
        {...props}
        filterOptions={(options, { inputValue }) => {
          const inputValueLowerCase = inputValue.toLowerCase();
          return options.filter((option) =>
            option.name.toLowerCase().startsWith(inputValueLowerCase)
          );
        }}
        renderInput={(params) => (
          <TextField
            required={props.required}
            name={props.name}
            error={props.error}
            helperText={props.helperText}
            value={inputValue}
            onChange={handleTextAreaChange}
            size="small"
            {...params}
            label={label}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {isLoading ? (
                    <CircularProgress
                      style={{ color: colorPrimary }}
                      size={20}
                    />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </>
  );
};

export default CoreAutoComplete;
